module.exports = __webpack_public_path__ + "c197e39f0f1477d18199ff52cb28448e.svg";